import { v4 as newGuid } from 'uuid'

export interface Message {
    id: string
    role: 'user' | 'agent' | 'suggested'
    content: string
    dateCreated: Date

    userId?: string // userId is only set for user messages
    promptMessageId?: string // used to link an agent's response to a user's prompt
    isLiked?: boolean // used to show feedback

    isPlaceholder?: boolean // used to show loading state
    isGreeting?: boolean // used to indicate the greeting message
    isError?: boolean // used to indicate an error
}

export const PlaceholderMessage: Message = {
    id: newGuid(),
    role: 'agent',
    content: 'Loading...',
    dateCreated: new Date(),
    isPlaceholder: true,
}

export const GreetingMessage: Message = {
    id: newGuid(),
    role: 'agent',
    content: `Hi {user}, see what's possible with Deltek Dela in Specpoint!`,
    dateCreated: new Date(),
    isGreeting: true,
}

export const SuggestedMessages: Message[] = [
    {
        id: newGuid(),
        role: 'suggested',
        content: `What are the main considerations when specifying a TPO roofing system?`,
        dateCreated: new Date(),
    },
    {
        id: newGuid(),
        role: 'suggested',
        content: `Provide an example of how to specify a paint system for interior gypsum board walls in a commercial office building.`,
        dateCreated: new Date(),
    },
    {
        id: newGuid(),
        role: 'suggested',
        content: `What are the key standards and codes that should be referenced in a specification section for aluminum-framed storefronts?`,
        dateCreated: new Date(),
    },
]

export const ErrorMessage: Message = {
    id: newGuid(),
    role: 'agent',
    content: `Hmm, it seems like I'm experiencing some technical difficulties at the moment. Please try asking your question again in a few minutes, and I should be back to my usual helpful self.`,
    dateCreated: new Date(),
    isError: true,
}

export const AbortMessage: Message = {
    id: newGuid(),
    role: 'agent',
    content: `Request was aborted either due to timeout or was cancelled by the user.`,
    dateCreated: new Date(),
    isError: true,
}
